import { ReducerState } from '@/redux/reducers/reservation/checkInByReserve';
import { customerValidator, rentRoomValidator } from '@/pages/reservation/checkIn/validator';
import { ValidateSchema, createValidator } from '@/pages/reservation/utils/validator';

const allGuestList: (value: ReducerState['allGuestList'], data: ReducerState) => void = (
  value,
  data,
) => {
  customerValidator(value, {
    isAppendMode: data.commonInfo.isAppendMode,
    rentRoomList: data.rentRoomInfos || [],
  });
};

const rentRoomInfos: (value: ReducerState['rentRoomInfos'], data: ReducerState) => void = (
  value,
  data,
) => {
  rentRoomValidator(value, {
    categoryList: data.allRoomList || [],
  });
};

const mainSchema: ValidateSchema<ReducerState> = {
  allGuestList,
  rentRoomInfos,
};

export default createValidator<ReducerState>(mainSchema);
